module.exports = __webpack_public_path__ + "static/img/cargo.bbe26b2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cargo.jpg
// module id = llbz
// module chunks = 0